export const BLOCK_TYPE_COOKIE_DECLARATION = 'cookieDeclaration';
